import jssVariables from "../../../jss_setup";

export const footer = {
  footer: {
    gridGap: `calc(${jssVariables.normal_gap} * 4)`,
    background: "none",
    smallscreen: {
      gridTemplateColumns: "repeat(4, minmax(11rem, max-content))",
      gridGap: `calc(${jssVariables.normal_gap} * 4)`,
    },
    bigscreen: {
      gridTemplateColumns: "repeat(4, minmax(14rem, max-content))",
    },
  },
  footerContainer: {
    width: "100vw",
    paddingTop: 0,
  },
  logo: {
    justifySelf: "start",
    width: "60vw",
    smallscreen: {
      width: "15rem",
    },
  },
  groupIcon: {
    display: "none",
  },
  socialMediaLabel: {
    display: "none",
  },
  group: {
    gridTemplateColumns: "1fr",
    color: jssVariables.colors.text.light,
  },
  emptyIconSpace: {
    display: "none",
  },
  quickLinkLabel: {},
  section: {},
};
